import { api } from './api';
import axios from 'axios';
import {
  GetLabelSettingsResponse,
  SaveLabelSettingsRequest,
} from '../types/label';

export const labelService = {
  getLabelSettings: async (
    userId: number | string
  ): Promise<GetLabelSettingsResponse> => {
    const response = await api.post<GetLabelSettingsResponse>(
      `/getLabelSettings`,
      {
        userId: Number(userId),
      }
    );
    return response.data;
  },

  saveLabelSettings: async (
    payload: SaveLabelSettingsRequest
  ): Promise<{ success: boolean; message: string }> => {
    const response = await api.post('/saveUserLabelSettings', payload);
    return response.data;
  },

  uploadLogo: async (
    file: File,
    userId: number | string
  ): Promise<{ success: boolean; url?: string; message?: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userid', userId.toString());

    const response = await api.post('/uploadLogoImage', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },
};
